import * as React from 'react';
import { useRef, useState } from 'react';
import Button from '../Button/Button';
import { DragAndDropProps } from './DragAndDrop.types';
import { styles } from './DragAndDropStyles';
import close from "../Icon/svgs/modal-close.svg";
import "./DragAndDrop.scss";
export default function DragAndDrop({
  onUpload,
  children,
  count,
  hoverText = 'Drop files here',
  containerClassName,
  changeButtonClassName,
  onDragEnter,
  onDragLeave,
  onDrop,
  thumbNailWidth,
  thumbNailHeight,
  showThumbNail,
  showChangeThumbNailButton,
  changeThumbNailButtonLabel,
  testId,
}: DragAndDropProps): React.ReactElement {
  const [dragging, setDragging] = useState(false);
  const [imgUrl, setImgUrl] = useState("");
  const drag = useRef(null);
  const drop = useRef(null);
  const inputRef = useRef(null);
  React.useEffect(() => {
    // @ts-ignore
    document.addEventListener('dragover', handleDragOver);
    // @ts-ignore
    document.addEventListener('drop', handleDrop);
    // @ts-ignore
    document.addEventListener('dragenter', handleDragEnter);
    // @ts-ignore
    document.addEventListener('dragleave', handleDragLeave);

    return () => {
      // @ts-ignore
      document.removeEventListener('dragover', handleDragOver);
      // @ts-ignore
      document.removeEventListener('drop', handleDrop);
      // @ts-ignore
      document.removeEventListener('dragenter', handleDragEnter);
      // @ts-ignore
      document.removeEventListener('dragleave', handleDragLeave);
    };
  }, [drop]);

  const handleDragOver = (e: DragEvent) => {
    if (drop.current && !drop.current.contains(e.target)) {
      // Return if event is not for the current element
      return
    }
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: DragEvent) => {
    if (drop.current && !drop.current.contains(e.target)) {
      // Return if event is not for the current element
      return
    }
    e.preventDefault();
    e.stopPropagation();

    setDragging(false);

    const files = e.dataTransfer ? [...e.dataTransfer.files as any] : [];

    onDrop && onDrop(files);

    handleUpload(files);
  };

  const handleDragEnter = (e: DragEvent) => {
    if (drop.current && !drop.current.contains(e.target)) {
      // Return if event is not for the current element
      return
    }
    e.preventDefault();
    e.stopPropagation();

    if (e.target !== drag.current) {
      setDragging(true);

      onDragEnter && onDragEnter();
    }
  };

  const handleDragLeave = (e: DragEvent) => {
    if (drop.current && !drop.current.contains(e.target)) {
      // Return if event is not for the current element
      return
    }
    e.preventDefault();
    e.stopPropagation();

    if (e.target === drag.current) {
      setDragging(false);

      onDragLeave && onDragLeave();
    }
  };

  const handleSelectFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = [...e.target.files as any];
    handleUpload(files);
  };

  // function called when change button is clicked -- needs to open up file selection window
  const changeThumbNail = () => {
    openFileDialog()
  }
  const onClose = () => {
    setImgUrl("")
    onUpload([])
  }
  const handleUpload = (files: File[]) => {
    if (showThumbNail && files.length === 1) {
      setImgUrl(URL.createObjectURL(files[0] as any))
    }
    onUpload(files);
  };
  const openFileDialog = () => {
    // @ts-ignore
    inputRef && inputRef.current.click();
  };
  return (
    <>
      {!imgUrl &&
        <div
          data-testid={testId ? testId : "drag-and-drop-input-field-container"}
          ref={drop}
          style={{
            ...styles.container,
          }}
          className={containerClassName}
          onClick={openFileDialog}
        >
          <input
            ref={inputRef}
            type='file'
            style={{ ...styles.input }}
            multiple={!count || count > 1}
            onChange={handleSelectFiles}
            data-testid="fileDropzone" />
          {dragging && (
            <div
              ref={drag}
              style={{
                ...styles.message,
              }}
            >
              {hoverText}
            </div>
          )}
          {children}
        </div>
      }
      {imgUrl &&
        <div data-testid={testId ? testId : "drag-and-drop-input-field-container"}>
          <div className="alteon-drag-and-drop-close">
            <img className="alteon-drag-and-drop-close-svg" src={`${close}`} onClick={onClose} />
            <img
              width={thumbNailWidth ? thumbNailWidth : "245px"}
              height={thumbNailHeight ? thumbNailHeight : "139px"}
              style={{ objectFit: 'cover' }}
              src={imgUrl}
            />
          </div>
          <input
            ref={inputRef}
            type='file'
            style={{ display: "none" }}
            multiple={!count || count > 1}
            onChange={handleSelectFiles}
          />
          {showChangeThumbNailButton &&
            <Button
              className={changeButtonClassName}
              onClick={changeThumbNail}
              displayDirection="flex"
              iconClass="alteon-icon-drag-and-drop-class"
              iconDirection={"left"}
              label={changeThumbNailButtonLabel ? changeThumbNailButtonLabel : "Change"}
            />
          }
        </div>
      }
    </>
  );
}
